export default __webpack_public_path__ + "static/media/crow.fbc75297.png";